import
{
    Form3
} from "@ews/react-data";

import
{
    FC
} from "react";

import s from '../SystemDocumentation.module.scss';

const TableForm3: FC<{ data: Form3; }> = ({
    data
}) =>
{

    if (!data) return <>no data</>;

    return <table id='system-documentation-form-3' data-name='Formblatt3' className={s.table}>
        <thead>
            <tr>
                <td style={{ width: "30px" }}></td>
                <td style={{ width: "250px" }}></td>
                <td style={{ width: "80px" }}></td>
                <td style={{ width: "250px" }}></td>
                <td style={{ width: "65px" }}></td>
                <td style={{ width: "65px" }}></td>
                <td style={{ width: "65px" }}></td>
                <td style={{ width: "65px" }}></td>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className={`${s.bT} ${s.bL} ${s.bR} ${s.title}`} colSpan={4}>Brandmeldeanlage</td>
                <td className={`${s.b} ${s.title}`} colSpan={4}>TRVB 123 S</td>
            </tr>
            <tr>
                <td className={`${s.bB} ${s.bL} ${s.bR} ${s.title} ${s.bold}`} rowSpan={2} colSpan={4}>Einreichung</td>
                <td className={`${s.bR} ${s.title}`} colSpan={4}>Anhang 1</td>
            </tr>
            <tr>
                <td className={`${s.bR} ${s.title}`} colSpan={4}>Formblatt 3</td>
            </tr>
            <tr>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}  >17.1</td>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Externe Alarmierungseinrichtungen  gemäß EN 54-XX</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Stück</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Art</td>
                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >Type</td>
            </tr>
            {data.externalAlarmDevices && (
                <tr>
                    <td colSpan={1}>{data.externalAlarmDevices.pieces}</td>
                    <td colSpan={1}>{data.externalAlarmDevices.kind}</td>
                    <td colSpan={2}>{data.externalAlarmDevices.type}</td>
                </tr>
            )}
            <tr>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}  >17.2</td>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Sonstige Alarmgeräte für  Brandmeldungen</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Stück</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Art</td>
                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >Type</td>
            </tr>
            {data.otherAlarmDevicesForFireMessages && (
                <tr>
                    <td colSpan={1}>{data.otherAlarmDevicesForFireMessages.pieces}</td>
                    <td colSpan={1}>{data.otherAlarmDevicesForFireMessages.kind}</td>
                    <td colSpan={2}>{data.otherAlarmDevicesForFireMessages.type}</td>
                </tr>
            )}
            <tr>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}  >18</td>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Sonstige Geräte</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Stück</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Art</td>
                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >Type</td>
            </tr>
            {data.otherDevices && (
                <tr>
                    <td colSpan={1}>{data.otherDevices.pieces}</td>
                    <td colSpan={1}>{data.otherDevices.kind}</td>
                    <td colSpan={2}>{data.otherDevices.type}</td>
                </tr>
            )}
            <tr>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}  >19</td>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Funk-Komponenten</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Stück</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Art</td>
                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >Type</td>
            </tr>

            <tr>
                <td rowSpan={6} className={`${s.b} ${s.aT} ${s.tL}`}  >20</td>
                <td rowSpan={6} className={`${s.b} ${s.aT} ${s.tL}`} >Interventionszeit</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Erkundungszeit:</td>
                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >{data.interventionTime?.explorationTime}</td>
            </tr>

            <tr>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Reaktionszeit:</td>
                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >{data.interventionTime?.reactionTime}</td>
            </tr>
            <tr>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Abschaltzeitpunkt:</td>
                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >{data.interventionTime?.shutdownTime}</td>
            </tr>
            <tr>
                <td colSpan={6} rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >- </td>
            </tr>
            <tr>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Sprinkleranlage:</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Ja</td>
                {data.interventionTime?.sprinklerSystem ?
                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                }
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Nein</td>
                {data.interventionTime?.sprinklerSystem ?
                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td>
                }
            </tr>
            <tr>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Hauptberufliche Betriebsfeuerwehr:</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Ja</td>
                {data.interventionTime?.fullTimeCompanyFireBrigade ?
                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                }
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Nein</td>
                {data.interventionTime?.fullTimeCompanyFireBrigade ?
                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td>
                }
            </tr>
            <tr>
                <td rowSpan={5} className={`${s.b} ${s.aT} ${s.tL}`}  >21</td>
                <td rowSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} >Angesteuerte Brandschutztechnische  Anlagen</td>
                {data.triggeredFireProtectionSystems?.gasExtinguishingSystem ?

                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                }
                <td colSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} >Gaslöschanlagen</td>
            </tr>
            <tr>
                {data.triggeredFireProtectionSystems?.smokeAndHeatExtractionSystem ?

                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                }
                <td colSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} >RWA</td>
            </tr>
            <tr>
                {data.triggeredFireProtectionSystems?.directlyConnectedAlarmSystem ?

                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                }
                <td colSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} >DBA</td>
            </tr>
            <tr>
                {data.triggeredFireProtectionSystems?.electricalNotificationSystem ?

                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                }
                <td colSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} >ENS</td>
            </tr>
            <tr>
                {data.triggeredFireProtectionSystems?.preControlledSprinklerSystem ?

                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                }
                <td colSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} >Vorgesteuerte Sprinkleranlage</td>
            </tr>
            <tr>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >22</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >Bemerkungen</td>
                <td colSpan={6} className={`${s.b} ${s.aT} ${s.tL}`} >{data.remarks}</td>
            </tr>
            <tr>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}  ></td>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Alarmverifizierung</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Bereich</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Text</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Art der Verifikation</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >von - bis</td>
            </tr>
            <tr>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}  ></td>
                <td rowSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Module</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Stück</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Art</td>
                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >Type</td>
            </tr>
        </tbody>
    </table>;
};

export default TableForm3;
